import React, { useState, FormEvent } from 'react';
import {
  Container,
  Typography,
  Box,
  Button,
  Card,
  CardContent
} from '@mui/material';
import NewsForm from '../../components/news-form-component/newsFormWidget';
import GenericInput from 'src/components/input-components/GenericTextInput';
import ImagePicker from 'src/components/input-components/GenericImagePicker';
import { DataService } from 'src/services/data-service';
import { useNavigate } from 'react-router';

interface AddNewItemNews {
  title: string;
  content: string;
  imageUrl: string;
  status: string;
}

export const AddNewItem: React.FC = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState<AddNewItemNews>({
    title: '',
    content: '',
    imageUrl: '',
    status: ''
  });
  
  // State to handle image picker open/close
  const [imagePickerOpen, setImagePickerOpen] = useState<boolean>(false);

  const handleChange = (name: string, value: string) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      const payload = {
        Title: formData.title,
        Content: formData.content,
        ImageUrl: formData.imageUrl
      };

      const response = await DataService.post('api/article/create', payload);

      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(errorMessage);
      }

      const result = await response.json();
      console.log(result);
      navigate(`/web-builder/news`);
    } catch (err) {
      console.error('Error creating page:', err);
    }

    // Reset form (if desired)
    setFormData({
      title: '',
      content: '',
      imageUrl: '',
      status: ''
    });
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Card>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Add News
          </Typography>

          {/* Title Field */}
          <GenericInput
            type="text"
            name="title"
            title="Title"
            value={formData.title}
            onChange={(value) => handleChange('title', value)}
          />

          {/* Image Field: Preview and Picker */}
          <Box sx={{ mt: 2 }}>
            {formData.imageUrl && (
              <img
                src={formData.imageUrl}
                alt="preview"
                style={{
                  width: '20%',
                  maxHeight: '500px',
                  marginBottom: '10px'
                }}
              />
            )}
            <Typography variant="h6">Select an Image</Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setImagePickerOpen(true)}
            >
              Choose Image
            </Button>
          </Box>

          <ImagePicker
            open={imagePickerOpen}
            onClose={() => setImagePickerOpen(false)}
            onSelect={(imageUrl: string) => {
              handleChange('imageUrl', imageUrl);
              setImagePickerOpen(false);
            }}
          />

          {/* Content Editor */}
          <NewsForm
            formData={formData}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
          />
        </CardContent>
        <Button onClick={handleSubmit}>Submit</Button>
      </Card>
    </Container>
  );
};
